module.exports = __webpack_public_path__ + "img/1585695950.88ebda77.jpg";